var MantleWindow = MantleWindow || {};

(function ($, Drupal) {
  var $modules = $('.js-makeup-looks--v1');

  $modules.removeClass('js-makeup-looks--v1');
  $modules.addClass('js-makeup-looks--dale');

  Drupal.behaviors.makeupLooksDale = {
    attach: function (context) {
      var $modules = $('.js-makeup-looks--dale', context);

      $modules.each(function () {
        var $module = $(this);
        var $carousel = $('.js-makeup-looks-pages', $module);
        var $links = $('.js-look-page', $module);
        var $pages = $('.js-look-page-item', $module);
        var pageSet = false;
        var lastPage = null;

        function setPage(index) {
          // Do not reset on responsive
          if (index === null) {
            index = 0;
            if (lastPage !== null) {
              index = lastPage;
            }
          }
          $links.filter('.active').removeClass('active');
          $links.eq(index).addClass('active');
          $pages.filter('.active').removeClass('active');
          $pages.eq(index).addClass('active');
          $pages.filter('.active').stop().fadeIn();
          $pages.filter(':not(.active)').stop().hide();

          $pages.eq(index).find('.slick-initialized').slick('setPosition');
          lastPage = index;
        }

        function setPageFromAnchor() {
          pageSet = true;

          // TRy to grab hash
          var pageIndex = 0;
          var hash = null;
          var hashMatched = false;

          if (window.location.hash) {
            hash = window.location.hash.substring(1);
            // Try to match anchor
            $links.each(function (i, obj) {
              var $link = $(obj);
              var title = $link.text();

              title = title.replace(/\s/g, '');
              title = title.toLowerCase();
              if (hash === title) {
                pageIndex = i;
                hashMatched = true;

                return false;
              }
            });
          }

          setPage(pageIndex);

          if (hashMatched) {
            window.setTimeout(function () {
              $('body,html').animate(
                {
                  scrollTop: $module.offset().top - 200
                },
                800 // speed
              );
            }, 300);
          }
        }

        function updateResponsive() {
          if ($carousel.hasClass('slick-initialized')) {
            $carousel.slick('unslick');
          }
          var isMobile = Unison.fetch.now().name === 'small';

          if (isMobile && $carousel.children().length > 1) {
            $carousel.slick({
              arrows: false,
              focusOnSelect: true,
              centerMode: true,
              centerPadding: '35%',
              slidesToShow: 1,
              adaptiveHeight: false,
            });
          }

          $carousel.off('afterChange').on('afterChange', function (event, slick, index) {
            if (isMobile) {
              setPage(index);
            }
          });

          $links.off('click.open').on('click.open', function (event) {
            event.preventDefault();
            var index = $(this).parent().index();

            if (isMobile) {
              index = $carousel.slick('slickCurrentSlide');
            }
            setPage(index);
          });

          if (pageSet) {
            setPage(null);
          } else {
            setPageFromAnchor();
          }
        }
        updateResponsive();
        MantleWindow.onResizeWidth(updateResponsive, 'makeup', 50);
      });
    }
  };
})(jQuery, Drupal);
